import { render, staticRenderFns } from "./TruckPresets.vue?vue&type=template&id=50581c59&"
import script from "./TruckPresets.vue?vue&type=script&lang=js&"
export * from "./TruckPresets.vue?vue&type=script&lang=js&"
import style0 from "./TruckPresets.vue?vue&type=style&index=0&id=50581c59&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports